import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);

    if (location.hash) {
      requestAnimationFrame(() => {
        document.getElementById(location.hash.slice(1))?.scrollIntoView();
      });
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.hash]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Queens Bench', path: '/properties/queens-bench' },
    { name: 'Golden Triangle', path: '/properties/golden-triangle' },
    { name: 'Tokenization', path: '/tokenization' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md shadow-lg shadow-black/50' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="/images/external/logo-readdy.png"
              alt="ReserveX Capital Ltd"
              className="h-16 md:h-20 w-auto"
            />
          </Link>

          {/* Center Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium transition-colors duration-300 cursor-pointer group ${
                  location.pathname === link.path ? 'text-[#D4AF37]' : 'text-[#F5DEB3] hover:text-[#D4AF37]'
                }`}
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#D4AF37] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
          </div>

          {/* Right CTAs */}
          <div className="hidden lg:flex items-center gap-4">
            <a
              href="/#investor-access"
              className="px-6 py-2.5 border border-[#D4AF37] text-[#D4AF37] text-sm font-semibold rounded-full hover:bg-[#D4AF37]/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Investor Data Room
            </a>
            <a
              href="/#investor-access"
              className="px-6 py-2.5 bg-[#D4AF37] text-black text-sm font-semibold rounded-full hover:bg-[#F5DEB3] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Submit Property
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((open) => !open)}
            className="lg:hidden text-[#D4AF37] text-2xl cursor-pointer"
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-md border-t border-[#D4AF37]/20">
          <div className="max-w-7xl mx-auto px-6 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-base font-medium transition-colors duration-300 cursor-pointer ${
                  location.pathname === link.path ? 'text-[#D4AF37]' : 'text-[#F5DEB3] hover:text-[#D4AF37]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-3 space-y-3">
              <a
                href="/#investor-access"
                className="block w-full px-6 py-3 border border-[#D4AF37] text-[#D4AF37] text-center text-sm font-semibold rounded-full hover:bg-[#D4AF37]/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Investor Data Room
              </a>
              <a
                href="/#investor-access"
                className="block w-full px-6 py-3 bg-[#D4AF37] text-black text-center text-sm font-semibold rounded-full hover:bg-[#F5DEB3] transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Submit Property
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
